module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = OMN4
// module chunks = 26